/*
 * @Author: chenliang
 * @Date: 2021-02-02 15:00:32
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-05 13:53:46
 * @Description: file content
 */
import React, { Component } from 'react';

export default class LmmCard extends Component {
  static propTypes = {

  };

  render() {
      console.log(this.props.fouce != undefined && this.props.fouce == 1 ? 'lmm-card-fouce' : 'lmm-card-normal')
    return (
        <div className="home-lmm-card">
            <div className={this.props.fouce != undefined && this.props.fouce == 1 ? 'lmm-card-fouce' : 'lmm-card-normal'} onClick={() => {this.props.onClick()}}>
            <div className="title">
                {this.props.title}
            </div>
            {this.props.children}
            <div className="subtitle">
                {this.props.subtitle}
            </div>
            </div>
        </div>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/LmmCard.js